import React from "react";
import D3Funnel from "./D3MultiXAxisBarWithMarker";
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Typography,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import clsx from "clsx";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { appService } from "../../App/app.service";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Fragment } from "react";
import DatePicker from "../../components/DatePicker";
import * as d3 from "d3";
import Skeleton from "@material-ui/lab/Skeleton";
// import addHeaderdescription from "../../components/HeaderDescription";
import ExportPPtx from "../../components/ExportPPT";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";

const styles = (theme) => ({
  root: {},
  content: {},
  buttons: {
    display: "flex",
    justifyContent: "center",
    "& > *": {
      marginLeft: theme.spacing(1),
    },
  },
  inner: {
    height: 375,
    minWidth: 500,
  },
  chart: {
    height: "100%",
  },
});

class MultiXAxisBarWithMarker extends React.Component {
  chartRef = React.createRef();

  data = [
    { category: "Bookings (in $K)", score: 210, scale: [0, 1000], point: 350 },
    {
      category: "Opportunities with product bundles %",
      score: 17,
      scale: [0, 100],
      point: 25,
    },
    {
      category: "Opportunities from Healthcare %",
      score: 54,
      scale: [0, 100],
      point: 45,
    },
    {
      category: "Account size (# of users)",
      score: 1510,
      scale: [0, 10000],
      point: 2500,
    },
    {
      category: "Deals from new customers %",
      score: 30,
      scale: [0, 100],
      point: 60,
    },
    {
      category: "Pipeline from new products %",
      score: 37,
      scale: [0, 100],
      point: 52,
    },
  ];
  _rootNode = [];
  componentDidMount = () => {
    this._rootNode.map((n, i) =>
      D3Funnel.create(n, {
        data: [this.data[i]],
      })
    );
  };

  _setRef(componentNode) {
    this._rootNode.push(componentNode);
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid container spacing={2}>
        {/* {addHeaderdescription(
          "Rep level scorecard",
          "Examine how each rep is doing on the factors that drive the success of your top reps."
        )} */}
        <AddHeaderDescriptionWithHelperText
          header={`Rep level scorecard`}
          description={`Examine how each rep is doing on the factors that drive the success of your top reps.`}
          helperTextCharts={this.props.helperTextCharts}
        />

        <Grid item container spacing={2} justify="space-around">
          <Grid item xs={12}>
            <Card className={clsx(classes.root)} raised={true}>
              <CardHeader title="Personal performance scorecard for Edd Penlington for Q4 2021" />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    marginRight: 10,
                  }}
                >
                  <ExportPPtx
                    chartRef={this.chartRef}
                    title={"Rep level scorecard"}
                  />
                </div>
              </div>
              <Divider />

              <CardContent className={classes.content} ref={this.chartRef}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {this.data.map((d, i) => (
                    <div
                      key={i}
                      style={{ width: "100%", height: 100 }}
                      className="bar-container"
                      ref={this._setRef.bind(this)}
                    />
                  ))}
                  <Typography>
                    <span
                      style={{
                        color: "rgb(84, 130, 53)",
                        fontSize: "20px",
                        transform: "scale(1, 2)",
                        display: "inline-block",
                      }}
                    >
                      ◆
                    </span>{" "}
                    where the top performers are
                  </Typography>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  const {
    user,
    funnelFilters,
    waterfallData,
    persistentAlert,
    waterfallMinDate,
    waterfallMaxDate,
  } = state.app;

  return {
    funnelFilters,
    waterfallData,
    persistentAlert,
    waterfallMinDate,
    waterfallMaxDate,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
}

const mapDispatchToProps = (dispatch) => ({});

const connectedBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MultiXAxisBarWithMarker));
export { connectedBar as MultiXAxisBarWithMarker };
